import { IRouteMatch } from './IRouteMatch';
import { toParams } from './toParams';

export function matchRoute(
  path: string,
  routeExp: RegExp): IRouteMatch {

  if (path == null || path[0] !== '/')
    throw new Error('path is invalid, should start with "/"');

  const pathSplit = path.split('?');
  if (!pathSplit[0].endsWith('/'))
    pathSplit[0] += '/';
  path = pathSplit.join('?');

  const match = routeExp.exec(path) as any;
  routeExp.lastIndex = 0;

  if (match) {
    const { __search, ...params } = match.groups;

    return {
      params: Object.keys(params).length ? params : null,
      search: toParams(__search)
    };
  }

  return null;
}


